// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.navbar-container[data-v-540a8014]{\n  background-color:#fff;\n  justify-content:space-between;\n  width:100%;\n  padding:.5rem 1rem;\n  color:#1a5cac;\n  box-shadow:0 4px 4px rgba(0,0,0,.05)\n}\n.navbar-container[data-v-540a8014],.navbar-container .navbar-brand[data-v-540a8014]{\n  display:flex;\n  align-items:center\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
